@if (node()) {
<div class="user-panel">
    <form class="user-form" [formGroup]="$any(formGroup())" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden">
                    <a class="tab-link" [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a>
                </li>
                }
            </ul>
        </div>
        <div class="body">
            @if (!node()!._system) {
            <div class="row">
                <div class="content-field">
                    <app-text [formGroup]="$any(formGroup())" [meta]="metaEmail" [model]="node()!.email"></app-text>
                    <app-role-picker [formGroup]="$any(formGroup())" [meta]="metaRoles" [model]="node()!.roles" groupBy="parent.name"></app-role-picker>
                </div>
            </div>
            }
        </div>
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
                <button type="button" class="button button-big" (click)="onPassword()">
                    <mat-icon class="regular-icon">password</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
}
